import { CategoryActionTypes } from './constants';

export interface CategoryNode {
    id: number;
    name: string;
    slug: string;
    imageUrl: string | null;
    displayOrder: number;
    isActive: boolean;
    parentId: number | null;
    createdAt?: string;
    updatedAt?: string;
    children?: CategoryNode[];
    _count?: { children: number; products: number };
}

const INIT_STATE = {
    categories: [] as CategoryNode[],
    categoryTree: [] as CategoryNode[],
    categoryProducts: [] as any[],
    categoryProductsTotal: 0,
    categoryProductsPages: 0,
    categoryProductsLoading: false,
    totalResults: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    treeLoading: false,
    error: null as string | null,
};

type State = typeof INIT_STATE;

type CategoryActionType = {
    type:
        | CategoryActionTypes.API_RESPONSE_SUCCESS
        | CategoryActionTypes.API_RESPONSE_ERROR
        | CategoryActionTypes.GET_CATEGORIES
        | CategoryActionTypes.GET_CATEGORY_TREE
        | CategoryActionTypes.GET_CATEGORY_PRODUCTS
        | CategoryActionTypes.CREATE_CATEGORY
        | CategoryActionTypes.UPDATE_CATEGORY
        | CategoryActionTypes.DELETE_CATEGORY;
    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

const Categories = (state: State = INIT_STATE, action: CategoryActionType): State => {
    const { type, payload } = action;

    switch (type) {
        case CategoryActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = payload;
            switch (actionType) {
                case CategoryActionTypes.GET_CATEGORIES:
                    return {
                        ...state,
                        categories: Array.isArray(data?.results) ? data.results : [],
                        totalResults: data?.totalResults ?? 0,
                        totalPages: data?.totalPages ?? 0,
                        currentPage: data?.currentPage ?? 1,
                        loading: false,
                        error: null,
                    };
                case CategoryActionTypes.GET_CATEGORY_TREE:
                    return {
                        ...state,
                        categoryTree: Array.isArray(data) ? data : [],
                        treeLoading: false,
                        error: null,
                    };
                case CategoryActionTypes.GET_CATEGORY_PRODUCTS:
                    return {
                        ...state,
                        categoryProducts: Array.isArray(data?.results) ? data.results : [],
                        categoryProductsTotal: data?.totalResults ?? 0,
                        categoryProductsPages: data?.totalPages ?? 0,
                        categoryProductsLoading: false,
                        error: null,
                    };
                case CategoryActionTypes.CREATE_CATEGORY:
                case CategoryActionTypes.UPDATE_CATEGORY:
                case CategoryActionTypes.DELETE_CATEGORY:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                    };
                default:
                    return state;
            }
        }

        case CategoryActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = payload;
            if (actionType === CategoryActionTypes.GET_CATEGORY_TREE) {
                return { ...state, treeLoading: false, error: error || 'An error occurred' };
            }
            return { ...state, loading: false, error: error || 'An error occurred' };
        }

        case CategoryActionTypes.GET_CATEGORIES:
        case CategoryActionTypes.CREATE_CATEGORY:
        case CategoryActionTypes.UPDATE_CATEGORY:
        case CategoryActionTypes.DELETE_CATEGORY:
            return { ...state, loading: true, error: null };

        case CategoryActionTypes.GET_CATEGORY_PRODUCTS:
            return { ...state, categoryProductsLoading: true, error: null };

        case CategoryActionTypes.GET_CATEGORY_TREE:
            return { ...state, treeLoading: true, error: null };

        default:
            return state;
    }
};

export default Categories;
